// extracted by mini-css-extract-plugin
export default {"faqList":"faqList_faqList__sVP13","list":"faqList_list__pHvgw","title":"faqList_title__qmpHW"};